import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { GipfRules } from './GipfRules';
export class GipfScoreHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        return PlayerNumberTable.ofSingle(GipfRules.getPlayerScore(state, Player.ZERO).get(), GipfRules.getPlayerScore(state, Player.ONE).get());
    }
}
